/** Supported language codes */
export const LANGUAGE_CODES = {
  en: "en",
  ar: "ar",
} as const;

export type LanguageCode = (typeof LANGUAGE_CODES)[keyof typeof LANGUAGE_CODES];

/** Default app language when none is stored */
export const DEFAULT_LANGUAGE: LanguageCode = LANGUAGE_CODES.en;

/** List of supported languages for dropdowns and iteration */
export const SUPPORTED_LANGUAGES: ReadonlyArray<{ code: LanguageCode; label: string }> = [
  { code: LANGUAGE_CODES.en, label: "English" },
  { code: LANGUAGE_CODES.ar, label: "Arabic" },
];
